import { DRAFTS, WORKFLOWS_MODERN_EDITOR } from '../../constants/gates';
import { useGate } from '../useGate';
export const useIsUngatedForDrafts = () => {
  const isUngatedForDrafts = useGate(DRAFTS);
  const isUngatedForModernEditor = useGate(WORKFLOWS_MODERN_EDITOR);

  // Drafts affects both modern and legacy editor flows, so we also require
  // Workflows:ModernEditor to ensure Drafts is only available on the modern editor.
  return isUngatedForDrafts && isUngatedForModernEditor;
};